import { render, staticRenderFns } from "./incomeAnalysis.vue?vue&type=template&id=1f056671&scoped=true&"
import script from "./incomeAnalysis.vue?vue&type=script&lang=js&"
export * from "./incomeAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./incomeAnalysis.vue?vue&type=style&index=0&id=1f056671&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f056671",
  null
  
)

export default component.exports